import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { AccionCortoPlazoService } from 'src/app/services/service.index';
declare const toastr: any;

@Component({
  selector: 'app-acp',
  templateUrl: './acp.component.html',
  styleUrls: []
})
export class AcpComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxSelectBoxComponent) selectBox: DxSelectBoxComponent
  datasourceAei: any[];
  datasourceAcp: any[];

  model: any = {
    id: 0,
    codigo: '',
    descripcion: '',
    plan_accion_id: '',

  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  datasourceIndicadorAcp: any[];
  vigencia: any[];
  formatCP: string = '';
  hasError: any;

  constructor(private _acps: AccionCortoPlazoService,) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getAccionPei();
    this.getAccionCortoPlazo();

  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, descripcion: false, plan_accion_id: false, indicadores: false };
  }

  getAccionPei() {
    this._acps.getAccionPei().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.datasourceAei = result.data;

        } else {
          this.datasourceAei = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }

  getAccionCortoPlazo() {
    this._acps.getAccionCortoPlazo().subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          
          this.datasourceAcp = result.data;

        } else {
          
          this.datasourceAcp = [];
        }
      },
      error => {
        console.log('Error', error);
      });
  }



  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.plan_accion_id = '';
    this.model.codigo = '';
    this.model.descripcion = '';
    this.model.indicadores = [];
    this.model.activo = true;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.model.indicadores = [];
    this.clearErrors();
    this.model.id = data.id;
    this.model.plan_accion_id = data.plan_accion_id;
    this.model.codigo = data.codigo;
    this.model.descripcion = data.descripcion;
    this.model.activo = true;
    this.popupVisibleAdd = true;


  }



  saveAccionCortoPlazo() {
    this.clearErrors();
    if (this.validate(this.model)) {

      if (this.model.id == 0) {

        this._acps.postAccionCortoPlazo(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getAccionCortoPlazo();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });

      }
      else {
        this._acps.putAccionCortoPlazo(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getAccionCortoPlazo();
              this.popupVisibleAdd = false;
              toastr.success('Datos guardados correctamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deleteAccionCortoPlazo() {
    this._acps.deleteAccionCortoPlazo(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getAccionCortoPlazo();
          this.popupVisibleDel = false;
          toastr.success('Proceso realizado correctamente.');
        } else {
          toastr.warning(result.data);
        }
      },
      (error) => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }

  getDisplayAei(item) {
    if (!item) {
      return '';
    }

    return `${item.codigo}:  ${item.descripcion}`;
  }  
}
